/*
  Variant-Badge-Filter per URL vorwaehlen

  ?badge=last-chance          aktiviert den Filter-Chip "Last Chance" im Sortenwahl-Block
  ?badge=vegan,glutenfrei     mehrere Chips (Handle = Badge-Titel als URL-Name, durch Komma getrennt)

  Der Chip wird wie ein Klick des Besuchers ausgeloest, die Filter-Logik (var_badges) bleibt also die einzige.
  Alter Parameter ?lastchance=last-chance gilt weiter als Kurzform fuer ?badge=last-chance
  (alte Links, z. B. von der Startseite und aus Kampagnen).
  Nach dem Anwenden werden die Parameter aus der Adresszeile entfernt.
*/
(function () {
  'use strict';

  var params = new URLSearchParams(window.location.search);
  var wanted = [];

  (params.get('badge') || '').split(',').forEach(function (handle) {
    handle = handle.trim().toLowerCase();
    if (handle && wanted.indexOf(handle) === -1) { wanted.push(handle); }
  });
  if (params.get('lastchance') === 'last-chance' && wanted.indexOf('last-chance') === -1) {
    wanted.push('last-chance');
  }
  if (!wanted.length) return;

  function findChip(handle) {
    var chips = document.querySelectorAll('.sinob_badges_design_variant_inner[data-badgename]');
    for (var i = 0; i < chips.length; i++) {
      if (chips[i].getAttribute('data-badgename') === handle) { return chips[i]; }
    }
    return null;
  }

  function apply() {
    wanted.forEach(function (handle) {
      var chip = findChip(handle);
      if (chip && !chip.classList.contains('variant_badge_active')) { chip.click(); }
    });
  }

  function cleanUrl() {
    var url = new URL(window.location.href);
    if (!url.searchParams.has('badge') && !url.searchParams.has('lastchance')) return;
    url.searchParams.delete('badge');
    url.searchParams.delete('lastchance');
    window.history.replaceState({}, document.title, url.toString());
  }

  function run() {
    apply();
    /* Der Sortenwahl-Block baut sich beim Laden teilweise neu auf: nach dem Laden noch einmal pruefen */
    window.addEventListener('load', function () {
      apply();
      cleanUrl();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
